import AppLayout from '../layouts/AppLayout'

const arme_tipo1 = 1
const arme_id4 = 4

export const indicadores = {
  path: '/indicadores',
  name: 'indicadores',
  component: AppLayout,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: ':arme_tipo?/:arme_id?',
      name: 'indicadores.index',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.index" */ '@/views/new-menu/indicadores/Index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores'
          }
        ]
      }
    },
    {
      path: 'cumplimiento/disponibilidad/:arme_tipo?/:arme_id?',
      name: 'indicadores.cumplimiento.disponibilidad',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.cumplimiento.disponibilidad" */ '@/views/informe/menu4calculo/menu4-1disponibilidad/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Disponibilidad'
          }
        ]
      }
    },
    {
      path: 'cumplimiento/indisponibilidad/:arme_tipo?/:arme_id?',
      name: 'indicadores.cumplimiento.indisponibilidad',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.cumplimiento.indisponibilidad" */ '@/views/informe/menu4calculo/menu4-5indisponibilidad/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Indisponibilidad'
          }
        ]
      }
    },
    {
      path: 'cumplimiento/eficiencia/:arme_tipo?/:arme_id?',
      name: 'indicadores.cumplimiento.eficiencia',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.cumplimiento.eficiencia" */ '@/views/informe/menu4calculo/menu4-3eficiencia/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Eficiencia'
          }
        ]
      }
    },
    {
      path: 'cumplimiento/carga/:arme_tipo?/:arme_id?',
      name: 'indicadores.cumplimiento.carga',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.cumplimiento.carga" */ '@/views/informe/menu4calculo/menu4-2carga/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Carga Instalada'
          }
        ]
      }
    },
    {
      path: 'pqrs/origendereportes/:arme_tipo?/:arme_id?',
      name: 'indicadores.pqrs.origendereportes',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.pqrs.origendereportes" */ '@/views/informe/menu5grafica/menu5-1operativa/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Por Origen De Reportes'
          }
        ]
      }
    },
    {
      path: 'pqrs/consolidado/porcuadrilla/:arme_tipo?/:arme_id?',
      name: 'indicadores.pqrs.consolidado.porcuadrilla',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.pqrs.consolidado.porcuadrilla" */ '@/views/informe/menu1consolidado/menu1-4cuadrilla/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Consolidado Por Cuadrilla'
          }
        ]
      }
    },
    {
      path: 'pqrs/luminaria/reporte/:arme_tipo?/:arme_id?',
      name: 'indicadores.pqrs.luminaria.reporte',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.pqrs.luminaria.reporte" */ '@/views/informe/menu2detallado/menu2-14luminariareporte/index.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Por Luminaria'
          }
        ]
      }
    },
    {
      path: 'graficas/poruso/:arme_tipo?/:arme_id?',
      name: 'indicadores.graficas.poruso',
      component: () =>
        import(
          /* webpackChunkName: "indicadores.graficas.poruso" */ '@/views/gerencia/grafica.vue'
        ),
      meta: {
        breadcrumb: [
          {
            text: 'Dashboard',
            to: { name: 'dashboard' },
            active: true
          },
          {
            text: 'Indicadores',
            to: {
              name: 'indicadores.index',
              params: { arme_tipo: arme_tipo1, arme_id: arme_id4 }
            }
          },
          {
            text: 'Por Uso'
          }
        ]
      }
    }
  ]
}
